export default __webpack_public_path__ + "static/media/catAndManChilling@2x.7f97bfdc.png";